<template>
  <Teleport defer to="#chat-modal-root">
    <div class="pointer-events-auto">
      <ModalLayout v-if="isOpen" small title="Feedback Modal" @close="handleCancel" :relative-to-parent="true">
        <div class="rounded-t-[10px] bg-white px-[20px] pt-[24px] sm:px-[24px]">
          <div
            @click.prevent="handleCancel"
            class="absolute right-[20px] top-[20px] flex h-[28px] w-[28px] cursor-pointer items-center justify-center rounded-full border border-gpx_gray-800 sm:right-[24px]"
          >
            <XMarkIcon
              class="heroicon-stroke-w-1.4 h-[16px] w-[16px] text-gpx_gray-200"
              @click="handleCancel"
            />
          </div>
          <div class="border-b border-b-gpx_gray-800 pb-[12px]">
            <div class="mb-[1px] text-xs font-medium text-gpx_gray-200">
              Feedback
            </div>
            <div class="text-gpx_black-100 text-lg font-semibold">
              What didn't you like?
            </div>
          </div>
          <div class="mt-[16px]">
            <textarea
              v-model="comment"
              placeholder="Optional: Tell us what went wrong..."
              class="form-textarea w-full resize-none rounded-md border border-gpx_gray-800 p-2 text-sm focus:border-transparent focus:ring-2 focus:ring-blue-500"
              rows="3"
              @keydown.escape="handleCancel"
            ></textarea>
          </div>
        </div>
        <div
          class="flex w-full gap-x-[12px] rounded-b-[10px] bg-white px-[20px] py-[20px] sm:px-[24px]"
        >
          <Button variant="tertiary" class="w-full" @click="handleCancel">
            Cancel
          </Button>
          <Button
            variant="destructive"
            class="w-full"
            @click="handleSubmit"
          >
            Submit
          </Button>
        </div>
      </ModalLayout>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, watch } from 'vue';
import ModalLayout from '@/layouts/ModalLayout.vue';
import { XMarkIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close', 'submit']);

const comment = ref('');

watch(() => props.isOpen, (newValue) => {
  if (!newValue) {
    comment.value = '';
  }
});

const handleCancel = () => {
  emit('close');
};

const handleSubmit = () => {
  emit('submit', comment.value);
};
</script>
